// This function allow to reference all chunks
__webpack_require__.cssAssetFileName = function(chunkId) {
	// return url for filenames based on template
	return "corn-catering-oo-web-" + chunkId + "." + "61fe49e9709bfb626115" + ".css";
};